import { ACHAccountType, ManualPaymentMethodType, PaymentMethodType } from '@business/entities/organization';

export function getManualPaymentMethods() {
  return [
    ManualPaymentMethodType.creditCard,
    ManualPaymentMethodType.ach,
    ManualPaymentMethodType.check,
    ManualPaymentMethodType.wire,
    ManualPaymentMethodType.other,
  ];
}

export function getPaymentTypes() {
  return [PaymentMethodType.card, PaymentMethodType.ach];
}

export function getACHAccountTypes() {
  return [ACHAccountType.personalCurrent, ACHAccountType.personalSaving, ACHAccountType.businessCurrent, ACHAccountType.businessSaving];
}
export function getACHAccountType(type: ACHAccountType) {
  switch (type) {
    case ACHAccountType.businessSaving:
      return 'Business Saving';
    case ACHAccountType.businessCurrent:
      return 'Business Checking';
    case ACHAccountType.personalSaving:
      return 'Personal Saving';
    case ACHAccountType.personalCurrent:
      return 'Personal Checking';
  }
}

export function addNMIScript(tokenizationKey: string) {
  const oldrcs = document.getElementById('nmi-script');

  if (oldrcs) {
    return;
  }
  const rcs = document.createElement('script');
  rcs.setAttribute('id', 'nmi-script');
  rcs.src = `https://secure.safewebservices.com/token/Collect.js`;
  rcs.setAttribute('data-tokenization-key', tokenizationKey);
  const rcs0 = document.getElementsByTagName('script')[0];
  rcs0.parentNode!.insertBefore(rcs, rcs0);
}

export function removeNMIScript() {
  const rcs = document.getElementById('nmi-script');

  if (rcs) {
    rcs.parentNode!.removeChild(rcs);
  }
}
